import { format, parseISO } from "date-fns";
import CardLayout from "../common/CardLayout";
import Table from "../common/table";
import { FaEye } from "react-icons/fa";
import TitleCard from "../common/TitleCard";
import { FaPen } from "react-icons/fa";
import DescricaoModal from "./DescricaoModal";
import { MdDelete } from "react-icons/md";

export default function RegistrosTable({ registros, openModalEdit, setItemToDelete }) {


    return <CardLayout>
        <TitleCard>Registros</TitleCard>
        <Table.Root>
            <Table.Head>
                    <Table.Header>
                        Data
                    </Table.Header>
                    <Table.Header>
                        Autor
                    </Table.Header>
                    <Table.Header>
                        Descrição
                    </Table.Header>
            </Table.Head>
            <Table.Body>
                {
                    registros.map((registro, i) => (
                        <Table.Row key={i}>
                            <Table.Data>
                                {format(parseISO(registro.data), "dd/MM/yyyy")}
                            </Table.Data>
                            <Table.Data>
                                {registro.nomeCompleto}
                            </Table.Data>
                            <Table.Data >
                                <div className="flex w-full justify-center items-center gap-3">
                                    <FaPen className="hover:text-lightBlue cursor-pointer" title="Editar Registro" onClick={() => openModalEdit(registro)}/>
                                    <DescricaoModal registro={registro}>
                                        <FaEye className="hover:text-lightBlue cursor-pointer" title="Ver Descrição"/>
                                    </DescricaoModal>
                                    <MdDelete className="hover:text-lightBlue cursor-pointer" title="Deletar Registro" onClick={() => setItemToDelete(registro)}/>
                                </div>
                            </Table.Data>
                        </Table.Row>
                    ))
                }
            </Table.Body>
        </Table.Root>
    </CardLayout>
}